module.exports = __webpack_public_path__ + "img/profile2-alertmsg.b014599f.png";